import axios from "axios";

export const fetchFoodData = async (dispatch: any) => {
    axios
        .get((process.env.REACT_APP_API_URL || '') + "/api/v1/menu")
        .then((response) => response.data)
        .then((data) => {
            dispatch({
                type: "SET_FOOD_ITEMS",
                foodItems: data,
            });
        })
        .catch((e) => {
            console.log(e);
        })
};